import { render, staticRenderFns } from "./index.layout.vue?vue&type=template&id=9ab33438&scoped=true&"
import script from "./index.layout.vue?vue&type=script&lang=js&"
export * from "./index.layout.vue?vue&type=script&lang=js&"
import style0 from "./index.layout.vue?vue&type=style&index=0&id=9ab33438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab33438",
  null
  
)

export default component.exports